// 缓存tab组件的状态
import { basicReduxGenerator } from '@/util/reduxGenerator/index'

export const {
							 reducer,
	
							 success,
							 error,
							 reset,
							 loading,
							 loaded
						 } = basicReduxGenerator({
  type: 'tab',
  state: {
    nearActive: false,
    nationalActive: false,
    current: 0
  }
})